// The Cash Report Set up guide (42_CashSetup.jsx · ModuleHelp, Max 01/11).
const en = {
  bandT: 'Is this in force?',
  bandB: 'This band says whether what you see is approved or a batch of changes still waiting. A change takes effect only once the Group CFO approves it.',
  checksT: 'Checks',
  checksB: 'The count of errors and warnings found in the lists. Tick the boxes to show only the rows with an issue, or only the rows you changed.',
  tabsT: 'The lists',
  tabsB: 'Entity, Account, User, Period, Exchange rates and the other lists every cash report reads. Pending changes and History show what moved and when.',
  importT: 'Import',
  importB: 'Load a whole list from an Excel file instead of typing row by row. You see it only if you may edit and no batch is waiting for a decision.',
  addT: 'Add a row',
  addB: 'Add an entity, account, user or other line to the list you are on. It joins the pending batch; nothing changes for the reports yet.',
  decideT: 'Send and approve',
  decideB: 'Once your changes are ready, send the batch for approval. The approver reads it here and approves it or sends it back with a note.',
};
const ko = {
  bandT: '적용 중인가요?',
  bandB: '이 띠는 지금 보이는 내용이 승인된 것인지, 대기 중인 변경 묶음인지 알려 줍니다. 변경은 Group CFO가 승인해야 적용됩니다.',
  checksT: '점검',
  checksB: '목록에서 발견된 오류와 경고 수입니다. 체크하면 문제가 있는 행만, 또는 내가 바꾼 행만 보입니다.',
  tabsT: '목록들',
  tabsB: '법인, 계좌, 사용자, 기간, 환율 등 모든 현금 보고서가 읽는 목록입니다. 대기 중인 변경과 이력에서 무엇이 언제 바뀌었는지 볼 수 있습니다.',
  importT: '가져오기',
  importB: '행별로 입력하는 대신 Excel 파일로 목록 전체를 올립니다. 편집 권한이 있고 결정을 기다리는 묶음이 없을 때만 보입니다.',
  addT: '행 추가',
  addB: '현재 목록에 법인, 계좌, 사용자 등 한 줄을 추가합니다. 대기 중인 변경 묶음에 들어가며, 보고서에는 아직 영향이 없습니다.',
  decideT: '전송과 승인',
  decideB: '변경이 준비되면 승인을 위해 묶음을 보냅니다. 승인자가 여기서 읽고 승인하거나 메모와 함께 되돌립니다.',
};
const vi = {
  bandT: 'Đã có hiệu lực chưa?',
  bandB: 'Dải này cho biết nội dung bạn đang thấy là đã duyệt hay là một lô thay đổi còn chờ. Thay đổi chỉ có hiệu lực sau khi Group CFO duyệt.',
  checksT: 'Kiểm tra',
  checksB: 'Số lỗi và cảnh báo tìm thấy trong các danh sách. Tick ô để chỉ hiện các dòng có vấn đề, hoặc chỉ các dòng bạn đã sửa.',
  tabsT: 'Các danh sách',
  tabsB: 'Entity, Account, User, Period, tỷ giá và các danh sách khác mà mọi báo cáo cash đều đọc. Thay đổi chờ duyệt và Lịch sử cho thấy cái gì đã đổi, vào lúc nào.',
  importT: 'Nhập file',
  importB: 'Nạp cả danh sách từ file Excel thay vì gõ từng dòng. Nút này chỉ hiện khi bạn có quyền sửa và không có lô nào đang chờ quyết định.',
  addT: 'Thêm dòng',
  addB: 'Thêm một entity, tài khoản, người dùng hay dòng khác vào danh sách đang mở. Dòng đó vào lô chờ duyệt; các báo cáo chưa thay đổi gì.',
  decideT: 'Gửi và duyệt',
  decideB: 'Khi các thay đổi đã sẵn sàng, gửi lô đi để duyệt. Người duyệt đọc ngay tại đây rồi duyệt hoặc trả lại kèm ghi chú.',
};
const zh = {
  bandT: '已生效了吗?',
  bandB: '这个横条说明你看到的内容是已批准的,还是仍在等待的一批变更。变更必须经 Group CFO 批准后才生效。',
  checksT: '检查',
  checksB: '列表中发现的错误和警告数量。勾选后只显示有问题的行,或只显示你修改过的行。',
  tabsT: '各个列表',
  tabsB: '主体、账户、用户、期间、汇率等所有现金报告都会读取的列表。待审变更和历史显示哪些内容在何时变动。',
  importT: '导入',
  importB: '用 Excel 文件一次性载入整个列表,不必逐行输入。只有你有编辑权限且没有批次等待决定时才会显示。',
  addT: '添加一行',
  addB: '在当前列表中添加一个主体、账户、用户等条目。它会进入待审批次,报告暂时不受影响。',
  decideT: '提交与批准',
  decideB: '变更准备好后,提交批次等待批准。审批人在这里阅读,然后批准或附上备注退回。',
};
const dictionary = { ns: 'tourCashSetup', en, ko, vi, zh };
export default dictionary;
